import { component } from 'picoapp';
import { getCart } from 'utils/cart';

export default component(async (node, ctx) => {
  const submit = node.querySelector('button[type="submit"]');

  const submitHandler = async (event) => {
    event.preventDefault();

    submit.textContent = window.theme.strings.adding;

    await window.WishlistKing.toolkit.requestAddToCart(node);

    // Delay rerender in case of moving items to cart
    setTimeout(async () => {
      const data = await getCart();
      ctx.emit('cart:updated', { cart: data });

      submit.textContent = window.theme.strings.addToCart;

      document.dispatchEvent(new CustomEvent('wishlist:render'));
    }, 500);
  };

  node.addEventListener('submit', submitHandler);
});
